import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import * as S from "./styled.js";
export const BlogItem = (props)=>{
    const { title , description , link , date , image , featured , share , tagLabel: _tagLabel , ...rest } = props;
    const size = featured ? {
        width: 1200,
        height: 600
    } : {
        width: 450,
        height: 450
    };
    const numberCaracters = featured ? 310 : 130;
    const desc = description && description?.length > numberCaracters ? `${description.slice(0, numberCaracters)}...` : description;
    return /*#__PURE__*/ _jsx(S.BlogItemContainer, {
        "data-testid": "BlogItem",
        className: classNames('blog-item__container', {
            'blog-item__container--featured': featured
        }),
        ...rest,
        children: /*#__PURE__*/ _jsxs(S.BlogItemMain, {
            children: [
                /*#__PURE__*/ _jsxs(S.BlogItemMainLink, {
                    href: link.href,
                    title: title,
                    target: link.target,
                    children: [
                        /*#__PURE__*/ _jsxs(S.BlogItemDate, {
                            children: [
                                /*#__PURE__*/ _jsx(S.BlogItemDay, {
                                    children: date.day
                                }),
                                /*#__PURE__*/ _jsxs(S.BlogItemMonthAndYear, {
                                    children: [
                                        date.month,
                                        " ",
                                        date.year
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(S.BlogItemImage, {
                            ...image,
                            resize: size,
                            ...size,
                            isLazy: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(S.BlogItemContent, {
                    children: [
                        /*#__PURE__*/ _jsx(S.BlogItemContentLink, {
                            href: link.href,
                            title: title,
                            target: link.target,
                            children: /*#__PURE__*/ _jsxs(S.BlogItemBlock, {
                                children: [
                                    /*#__PURE__*/ _jsx(S.BlogItemTitle, {
                                        children: title
                                    }),
                                    desc && /*#__PURE__*/ _jsx(S.BlogItemDescription, {
                                        children: desc
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(S.BlogItemFooter, {
                            children: [
                                /*#__PURE__*/ _jsx(S.BlogItemWrapper, {
                                    children: !!share?.length && /*#__PURE__*/ _jsx(S.BlogItemShareButtons, {
                                        children: share.map((shareItem)=>/*#__PURE__*/ _jsx(S.BlogItemIconLink, {
                                                href: shareItem.href,
                                                title: shareItem.title,
                                                target: shareItem.target,
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: `nico-${shareItem.icon}`
                                                })
                                            }, shareItem.href))
                                    })
                                }),
                                /*#__PURE__*/ _jsx(S.BlogItemWrapper, {
                                    children: /*#__PURE__*/ _jsx(S.BlogItemViewMore, {
                                        children: /*#__PURE__*/ _jsx(S.BlogItemViewMoreLink, {
                                            href: link.href,
                                            title: link.title,
                                            target: link.target,
                                            children: link.content
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default BlogItem;

//# sourceMappingURL=index.js.map